import {IPaginateProducts} from 'src/shared/common-dtos/get-all-paginate';
import ApiService from '../../../utils/base-api/api-service';
import {ICountryList, ICountryListData} from './dtos/country-list';
import {ICountrySearch} from './dtos/country-search';
import {ICreateCountry} from './dtos/create-country';
import {ICreateRegion} from './dtos/create-region';
import {IEditCountry} from './dtos/edit-country';
import {IEditRegion} from './dtos/edit-region';
import {IRegionList, IRegionListData} from './dtos/region-list';
import {DistrictsListParamsDto} from './dtos/districts-list-params-dto';
import {DistrictsListObjDto} from './dtos/districts-list-dto';
import {DistrictCreatePopupDto} from './dtos/district-create-popup-dto';

class CountriesService extends ApiService {
  constructor() {
    super({baseURL: '/AdminCountry'});
  }

  countryList(
    dataSearch: ICountrySearch,
    paginations: IPaginateProducts,
  ): Promise<ICountryList> {
    return this.post('/CountryList', dataSearch, {
      params: paginations,
    });
  }

  publishCountries(payload: string[]) {
    return this.post('/PublishSelected', payload);
  }

  unpublishCountries(payload: string[]) {
    return this.post('/unpublishSelected', payload);
  }

  createCountry(payload: ICreateCountry) {
    return this.post('/Create', payload);
  }

  editCountry(payload: IEditCountry) {
    return this.post('/Edit', payload);
  }

  deleteCountry(countryId: string) {
    return this.post(
      '/Delete',
      {},
      {
        params: {
          id: countryId,
        },
      },
    );
  }

  getCountryByID(countryId: string): Promise<ICountryListData> {
    return this.put(
      '/getCountryById',
      {},
      {
        params: {
          id: countryId,
        },
      },
    );
  }

  regionsList(regionsQuery: any): Promise<IRegionList> {
    return this.post('/Regions', {}, {params: regionsQuery});
  }

  getRegion(id: string): Promise<IRegionListData> {
    return this.put('/GetRegionPopup', {}, {params: {id}});
  }

  editRegion(payload: IEditRegion) {
    return this.post('/RegionEditPopup', payload);
  }

  createRegion(payload: ICreateRegion) {
    return this.post('/RegionCreatePopup', payload);
  }

  deleteRegion(regionId: string) {
    return this.post(
      '/RegionDelete',
      {},
      {
        params: {
          id: regionId,
        },
      },
    );
  }

  districts(input: DistrictsListParamsDto): Promise<DistrictsListObjDto> {
    return this.post('/Districts', null, {
      params: input,
    });
  }

  districtCreatePopup(input: DistrictCreatePopupDto) {
    return this.post('/DistrictCreatePopup', input);
  }

  districtDelete(input: string) {
    return this.post('/DistrictDelete', null, {
      params: {
        id: input,
      },
    });
  }

  districtEditPopup(input: DistrictCreatePopupDto) {
    return this.post('/DistrictEditPopup', input);
  }
}

export const countriesService = new CountriesService();
